import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CFormSelect,
  CFormInput,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilTrash } from '@coreui/icons'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import PlusIcon from '../../../assets/plus-icon.svg'
import AttachLink from '../attachLink'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail, validateLink } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { SYSTEM_METADATA_API } from 'src/views/utils/urls'
import TemplateAccordion from '../templateAccordion'
import { isEmpty } from 'lodash'
import LinkIcon from '../../../assets/link-icon.svg'
import DesignSettingOverlay from '../designSettingOverlay'

const UImediaFooterModal = ({
  componentData,
  modifyData,
  modalSpecificData,
  onCancel,
  isAdvancedEditAllowed,
}) => {
  // const { isEdit } = modalSpecificData
  const { userSessionObj } = useContext(GlobalContext)
  const { loader, setLoader } = useContext(AppContext)

  const [errorData, setErrorData] = useState({})
  const [imageS3key, setImageS3key] = useState('')
  const [imageData, setImageData] = useState([])
  const [columnOneMenus, setColumnOneMenus] = useState([])
  const [columnTwoMenus, setColumnTwoMenus] = useState([])
  const [header, setHeader] = useState('')
  const [contactEmail, setContactEmail] = useState('')
  const [phoneNum, setPhoneNum] = useState('')
  const [copyrightText, setCopyrightText] = useState('')
  const [socialHandles, setSocialHandles] = useState([])
  const [button, setButton] = useState({
    enabled: true,
    button_text: '',
    link: {
      type: '',
      data: {},
    },
  })
  const [styleConfig, setStyleConfig] = useState({})
  const [designSettingOptions, setDesignSettingOptions] = useState([])
  // const [siteMap, setSiteMap] = useState([])
  const [link, setLink] = useState({ type: '', data: {} }) // default footer form subscribe btn link

  const [linkModal, setLinkModal] = useState(false)
  const [linkModalColumn2, setLinkModalColumn2] = useState(false)
  const [siteMapIdx, setSiteMapIdx] = useState(0)

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  useEffect(() => {
    setLoader(categoryListLoading)
  }, [categoryListLoading])

  useEffect(() => {
    const imgData = [
      {
        title: '',
        id: 'mdImage',
        width: 141,
        height: 60,
        divwidth: '11.4375rem',
        divheight: '6.4375rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        btnMarginTop: '4px',
        uploadIconsize: '10px',
      },
    ]
    let tempdata = componentData.data
    // console.log(tempdata)

    if (tempdata?.style_config) {
      setStyleConfig(tempdata?.style_config)
    }

    setImageS3key(tempdata.image_s3key)
    setColumnOneMenus(tempdata.column_one_menus)
    setColumnTwoMenus(tempdata.column_two_menus)
    setHeader(tempdata.header)
    setContactEmail(tempdata.email)
    setPhoneNum(tempdata.phone)
    setCopyrightText(tempdata.copyright_text)
    setSocialHandles(tempdata.social_handles)
    setButton(tempdata.button)
    // setSiteMap(tempdata.site_map)

    imgData[0]['assetId'] = tempdata.image_s3key
    imgData[0]['imageUrl'] = getThumbnail(
      userSessionObj?.session_data?.cf_domain_name,
      tempdata.image_s3key,
    )

    setImageData(imgData)
  }, [])

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (imageS3key.trim().length === 0) {
      isFormValid = false
      temp.imageS3key = 'Upload Image!'
    }

    if (button.enabled && button.button_text.trim().length === 0) {
      isFormValid = false
      temp.button = 'Button Text Cannot be Empty!'
    }

    if (link.type && !validateLink(link).isValid) {
      isFormValid = false
      temp.link = validateLink(link).error
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const getStyleConfig = (keyArr = []) => {
    if (!componentData?.data?.style_config) {
      return []
    }
    let stylesArr = []
    for (let i = 0; i < keyArr.length; i++) {
      const key = keyArr[i]
      let styleObj = componentData?.data?.style_config[key]
      stylesArr.push(styleObj)
    }
    return stylesArr
  }

  const handleStyleSave = (data) => {
    let tempStyleObj = styleConfig
    for (let i = 0; i < data.length; i++) {
      const ele = data[i]
      tempStyleObj[ele.key] = ele
    }
    setStyleConfig({ ...tempStyleObj })
    setDesignSettingOptions([])
  }

  // save component data
  const handleSave = () => {
    if (!validateInfo()) return

    let elementObj = {
      image_s3key: imageS3key,
      column_one_menus: columnOneMenus,
      column_two_menus: columnTwoMenus,
      header: header,
      email: contactEmail,
      phone: phoneNum,
      copyright_text: copyrightText,
      social_handles: socialHandles,
      button: button,
      style_config: styleConfig,
    }

    modifyData(componentData.id, elementObj)
  }

  // delete social handle
  const deleteSocialHandle = (index) => {
    setSocialHandles((prevData) => prevData.filter((data, idx) => idx !== index))
  }
  // delete social handle

  // add social handle
  const addSocialHandle = () => {
    setSocialHandles((prev) => [
      ...prev,
      {
        name: '',
        url: '',
      },
    ])
  }
  // change social item Name
  const changeSocialItemName = (value, idx) => {
    let tempSocialHandles = socialHandles
    tempSocialHandles[idx] = { ...tempSocialHandles[idx], name: value }
    setSocialHandles([...tempSocialHandles])
  }
  // change social item Url  // not working
  const changeSocialItemUrl = (value, idx) => {
    let tempSocialHandles = socialHandles
    tempSocialHandles[idx] = { ...tempSocialHandles[idx], url: value }
    setSocialHandles([...tempSocialHandles])
  }

  // change site map item Name
  const changeSiteMapItemText = (state, setStateFunc, value, idx) => {
    let tempSiteMap = state
    tempSiteMap[idx] = { ...tempSiteMap[idx], text: value }
    setStateFunc([...tempSiteMap])
  }

  const [subLinkError, setsubLinkError] = useState('')
  // change site map sub heading link
  const changeSiteMapItemLink = (type, value, idx) => {
    // debugger
    if (!validateLink(value).isValid) {
      setsubLinkError(validateLink(value).error)
      return
    }
    let tempSiteMap = type === 'ONE' ? columnOneMenus : columnTwoMenus
    tempSiteMap[idx] = { ...tempSiteMap[idx], link: value }
    type === 'ONE' ? setColumnOneMenus([...tempSiteMap]) : setColumnTwoMenus([...tempSiteMap])
    type === 'ONE' ? setLinkModal(false) : setLinkModalColumn2(false)

    setLink({ type: '', data: {} })
  }

  // link modal opener
  const linkAssignModal = (type, link, idx) => {
    type === 'ONE' ? setLinkModal(true) : setLinkModalColumn2(true)
    setLink(link)
    setSiteMapIdx(idx)
  }

  let accordionItems = [
    {
      title: 'Add Logo',
      description: "Insert company's logo in the Footer",
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5' }}
          className=" px-4 py-3 d-flex flex-column justify-content-center align-items-center"
        >
          <ImageUploader data={imageData} />
          <span className="mt-2" style={{ fontSize: '11px', color: '#707070' }}>
            141 px X 60 px , maximum size 2 MB
          </span>
          <div className="message-text error-message">
            <p>{errorData.imageS3key}</p>
          </div>
        </div>
      ),
      itemStyle: '',
      enableColorPicker: isAdvancedEditAllowed && componentData?.data?.style_config,
      colorPickerFunction: () => {
        setDesignSettingOptions(getStyleConfig(['component_background', 'margin_background']))
      },
    },
    {
      title: 'Edit Sitemap',
      description: 'Specify the Sitemap and respective links',
      children: (
        <div
          style={{ backgroundColor: '#e5e5e5', overflowX: 'auto' }}
          className=" px-4 py-3 d-flex"
        >
          <div
            className="flex-shrink-0 position-relative"
            style={{
              width: '50%',
              paddingRight: '8%',
              borderRight: `1px #9b9494 solid`,
            }}
          >
            <h6 style={{ fontSize: '13px' }} className="">
              Column-1 menus
            </h6>
            {!isEmpty(columnOneMenus) &&
              columnOneMenus.map((sitemapitem, idx) => {
                return (
                  <div className="d-flex justify-content-between align-items-start mt-2" key={idx}>
                    <div style={{ width: '78%' }}>
                      <CustomDescriptionBox
                        limit={35}
                        rows={1}
                        value={sitemapitem.text}
                        onChange={(value) =>
                          changeSiteMapItemText(columnOneMenus, setColumnOneMenus, value, idx)
                        }
                        style={{ fontSize: '10px', borderRadius: '3px' }}
                        limitFontSize={'11px'}
                      />
                    </div>

                    <div
                      className="w-7 h-7 bg-[#20211c] d-flex justify-center items-center rounded-sm cursor-pointer"
                      onClick={() => linkAssignModal('ONE', sitemapitem.link, idx)}
                    >
                      <img src={LinkIcon} alt="" className="w-3 h-3" />
                    </div>
                    {linkModal && (
                      <CModal visible={linkModal} size="md" alignment="center">
                        <CModalBody>
                          <h6 style={{ fontWeight: '700', fontSize: '12px' }}>ADD LINK</h6>
                          <AttachLink
                            title=""
                            linkData={link}
                            id={'text1'}
                            categoryData={
                              categoryList
                                ? categoryList?.data.filter(
                                    (info, idx) => info.type === 'category' && info.status,
                                  )
                                : []
                            }
                            setLinkData={(value) => {
                              setsubLinkError('')
                              setLink(value)
                            }}
                          />
                          <div className="message-text error-message">
                            <p>{subLinkError}</p>
                          </div>
                        </CModalBody>
                        <CModalFooter style={{ borderTop: '0' }}>
                          <CButton
                            style={{
                              color: '#3a3838',
                              backgroundColor: 'white',
                              border: '1px solid #bdbdbd',
                              borderRadius: '5px',
                            }}
                            onClick={() => {
                              setLink({ type: '', data: {} })
                              setLinkModal(false)
                            }}
                          >
                            Cancel
                          </CButton>
                          <CButton
                            style={{
                              color: 'white',
                              backgroundColor: '#20211c',
                              border: '1px solid #bdbdbd',
                              borderRadius: '5px',
                            }}
                            onClick={() => changeSiteMapItemLink('ONE', link, siteMapIdx)}
                          >
                            Assign Link
                          </CButton>
                        </CModalFooter>
                      </CModal>
                    )}
                  </div>
                )
              })}
          </div>
          <div
            className="flex-shrink-0 position-relative"
            style={{
              width: '50%',
              paddingLeft: `8%`,
            }}
          >
            <h6 style={{ fontSize: '13px' }} className="">
              Column-2 menus
            </h6>
            {!isEmpty(columnTwoMenus) &&
              columnTwoMenus.map((sitemapitem, idx) => {
                return (
                  <div className="d-flex justify-content-between align-items-start mt-2" key={idx}>
                    <div style={{ width: '78%' }}>
                      <CustomDescriptionBox
                        limit={35}
                        rows={1}
                        value={sitemapitem.text}
                        onChange={(value) =>
                          changeSiteMapItemText(columnTwoMenus, setColumnTwoMenus, value, idx)
                        }
                        style={{ fontSize: '10px', borderRadius: '3px' }}
                        limitFontSize={'11px'}
                      />
                    </div>

                    <div
                      className="w-7 h-7 bg-[#20211c] d-flex justify-center items-center rounded-sm cursor-pointer"
                      onClick={() => linkAssignModal('TWO', sitemapitem.link, idx)}
                    >
                      <img src={LinkIcon} alt="" className="w-3 h-3" />
                    </div>
                    {linkModalColumn2 && (
                      <CModal visible={linkModalColumn2} size="md" alignment="center">
                        <CModalBody>
                          <h6 style={{ fontWeight: '700', fontSize: '12px' }}>ADD LINK</h6>
                          <AttachLink
                            title=""
                            linkData={link}
                            id={'column2'}
                            categoryData={
                              categoryList
                                ? categoryList?.data.filter(
                                    (info, idx) => info.type === 'category' && info.status,
                                  )
                                : []
                            }
                            setLinkData={(value) => {
                              setsubLinkError('')
                              setLink(value)
                            }}
                          />
                          <div className="message-text error-message">
                            <p>{subLinkError}</p>
                          </div>
                        </CModalBody>
                        <CModalFooter style={{ borderTop: '0' }}>
                          <CButton
                            style={{
                              color: '#3a3838',
                              backgroundColor: 'white',
                              border: '1px solid #bdbdbd',
                              borderRadius: '5px',
                            }}
                            onClick={() => {
                              setLink({ type: '', data: {} })
                              setLinkModalColumn2(false)
                            }}
                          >
                            Cancel
                          </CButton>
                          <CButton
                            style={{
                              color: 'white',
                              backgroundColor: '#20211c',
                              border: '1px solid #bdbdbd',
                              borderRadius: '5px',
                            }}
                            onClick={() => changeSiteMapItemLink('TWO', link, siteMapIdx)}
                          >
                            Assign Link
                          </CButton>
                        </CModalFooter>
                      </CModal>
                    )}
                  </div>
                )
              })}
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
      enableColorPicker: isAdvancedEditAllowed && componentData?.data?.style_config,
      colorPickerFunction: () => {
        setDesignSettingOptions(getStyleConfig(['sitemap']))
      },
    },
    {
      title: 'Add Contact Info & Copyright statement',
      description: 'Specify your contact information and copyright statement',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="">
            <h6 style={{ fontSize: '13px' }} className="">
              Header
            </h6>
            <CustomDescriptionBox
              limit={36}
              rows={1}
              value={header}
              onChange={(value) => setHeader(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }} className="">
              Email
            </h6>
            <CustomDescriptionBox
              limit={36}
              rows={1}
              value={contactEmail}
              onChange={(value) => setContactEmail(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Phone Number</h6>
            <CustomDescriptionBox
              limit={20}
              rows={1}
              value={phoneNum}
              onChange={(value) => setPhoneNum(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
          <div className="mt-1">
            <h6 style={{ fontSize: '13px' }}>Copyright Statement</h6>
            <CustomDescriptionBox
              limit={45}
              rows={1}
              value={copyrightText}
              onChange={(value) => setCopyrightText(value)}
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
      enableColorPicker: isAdvancedEditAllowed && componentData?.data?.style_config,
      colorPickerFunction: () => {
        setDesignSettingOptions(getStyleConfig(['header', 'email', 'phone', 'copyright']))
      },
    },
    {
      title: 'Add Social Media Links',
      description: 'Specify social links that you want to share with your viewers.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="">
            <h6 style={{ fontSize: '13px' }} className="">
              Select Social Link
              <span style={{ marginLeft: '13%' }}>URL</span>
            </h6>
            <div>
              {socialHandles.map((socialitem, idx) => (
                <div
                  className="d-flex justify-content-between items-center mb-3"
                  key={`${socialitem.name}${idx}`}
                >
                  <CFormSelect
                    size="sm"
                    style={{ width: '25%' }}
                    aria-label="Social handle seclector"
                    defaultValue={socialitem.name}
                    onChange={(e) => changeSocialItemName(e.target.value, idx)}
                  >
                    <option>Select</option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'facebook' ? true : null,
                      )}
                      value="facebook"
                    >
                      Facebook
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'twitter' ? true : null,
                      )}
                      value="twitter"
                    >
                      Twitter
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'instagram' ? true : null,
                      )}
                      value="instagram"
                    >
                      Instagram
                    </option>

                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'telegram' ? true : null,
                      )}
                      value="telegram"
                    >
                      Telegram
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'youtube' ? true : null,
                      )}
                      value="youtube"
                    >
                      Youtube
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'bitchute' ? true : null,
                      )}
                      value="bitchute"
                    >
                      Bitchute
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'tiktok' ? true : null,
                      )}
                      value="tiktok"
                    >
                      Tiktok
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'rumble' ? true : null,
                      )}
                      value="rumble"
                    >
                      Rumble
                    </option>
                    <option
                      disabled={socialHandles.find((social) =>
                        social.name === 'boxcast' ? true : null,
                      )}
                      value="boxcast"
                    >
                      Boxcast
                    </option>
                  </CFormSelect>
                  <CFormInput
                    type="text"
                    size="sm"
                    style={{ width: '61%' }}
                    placeholder=""
                    aria-label="sm input example"
                    value={socialitem.url}
                    onChange={(e) => changeSocialItemUrl(e.target.value, idx)}
                  />
                  <div
                    className="w-[24px] h-[24px] d-flex justify-center items-center"
                    style={{ border: '1px solid #707070', borderRadius: '50%' }}
                    onClick={() => deleteSocialHandle(idx)}
                  >
                    <CIcon icon={cilTrash} size="md" />
                  </div>
                </div>
              ))}
            </div>
            {/* Add Link */}
            <div
              className="inline-flex justify-between items-center cursor-pointer"
              onClick={() => addSocialHandle()}
            >
              <div
                className="h-[24px] w-[24px] rounded-full bg-[#2172eb] flex justify-center items-center shadow"
                style={{ boxShadow: '2px 2px 4px 0 rgba(0, 0, 0, 0.3)' }}
              >
                <img src={PlusIcon} className="w-[15px] h-[15px]" alt="trashicon" />
              </div>
              <p className="text-xs text-[#2172eb] font-medium ml-1 mb-0">ADD LINK</p>
            </div>
            {/* Add Link Ending */}
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
      enableColorPicker: isAdvancedEditAllowed && componentData?.data?.style_config,
      colorPickerFunction: () => {
        setDesignSettingOptions(getStyleConfig(['social_media_icon']))
      },
    },
    {
      title: 'Add Footer Button',
      description:
        'Specify the link to which you would like to redirect after clicking the Button of the template.',
      children: (
        <div style={{ backgroundColor: '#e5e5e5' }} className=" px-4 py-3">
          <div className="">
            <h6 style={{ fontSize: '13px' }} className="">
              Footer Button Text
            </h6>
            <CustomDescriptionBox
              limit={50}
              rows={1}
              value={button.button_text}
              onChange={(value) =>
                setButton((prevState) => {
                  return {
                    ...prevState,
                    button_text: value,
                  }
                })
              }
              style={{ fontSize: '12px' }}
              limitFontSize={'11px'}
            />
          </div>

          <AttachLink
            linkData={button.link}
            id={'text1'}
            categoryData={
              categoryList
                ? categoryList?.data.filter((info, idx) => info.type === 'category' && info.status)
                : []
            }
            setLinkData={(value) => {
              clearError('ctaButtonLink')
              setButton((prevState) => {
                return {
                  ...prevState,
                  link: value,
                }
              })
            }}
          />
          <div className="message-text error-message">
            <p>{errorData?.link}</p>
          </div>
        </div>
      ),
      itemStyle: 'mt-4',
      enableSwitch: true,
      switchChecked: button.enabled,
      switchToggle: (event) => {
        let { checked } = event.target
        setButton((prevState) => {
          return {
            ...prevState,
            enabled: checked,
          }
        })
      },
      enableColorPicker: isAdvancedEditAllowed && componentData?.data?.style_config,
      colorPickerFunction: () => {
        setDesignSettingOptions(getStyleConfig(['footer_button']))
      },
    },
  ]
  return (
    <>
      <CModal scrollable size="lg" className="" visible={true}>
        {!isEmpty(designSettingOptions) && (
          <DesignSettingOverlay
            width={'36%'}
            options={designSettingOptions}
            onCancel={() => setDesignSettingOptions([])}
            handleSave={(data) => handleStyleSave(data)}
          />
        )}
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader className="d-flex justify-content-center" style={{ borderBottom: '0' }}>
          <p style={{ fontSize: '1.3rem' }}>
            <b style={{ fontWeight: '500' }}>Footer Editor</b>
          </p>
        </CModalHeader>
        <CModalBody
          style={{ minHeight: '72vh' }}
          className=" static-scrollbar-class d-flex flex-column justify-content-between"
        >
          <div className="d-flex justify-content-center">
            <div
              style={{ width: '82%' }}
              className="flex flex-column justify-content-center align-items-center"
            >
              <TemplateAccordion items={accordionItems} styles={''} />
            </div>
          </div>
        </CModalBody>
        <CModalFooter className="d-flex justify-content-center border-top-0">
          <div
            className="mt-4 d-flex align-items-end justify-content-between"
            style={{ width: '80%' }}
          >
            <span className="mt-2" style={{ fontSize: '12px' }}>
              * Leave a section blank to remove it from the component. Do not fill any details.
            </span>
            <CButton
              style={{ color: 'black', border: '1px solid black' }}
              className="mx-4 bg-white rounded-1 btn-focus-none"
              onClick={onCancel}
            >
              Cancel
            </CButton>
            <CButton
              style={{ backgroundColor: '#20211c' }}
              className="px-3 rounded-1 btn-focus-none"
              onClick={handleSave}
            >
              Save
            </CButton>
          </div>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default UImediaFooterModal
